import styled from 'styled-components'

import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Title = styled.div<{ $mode: ThemeModeType }>`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => (props.$mode === 'Light' ? props.theme.color.p500 : props.theme.color.white)};
    margin-bottom: 8px;

    span {
        ${(props) => props.theme.gradient.nector};
        background-clip: text;
        color: transparent;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
    }
`
